import { render, staticRenderFns } from "./searchSC.vue?vue&type=template&id=277e27a8&"
import script from "./searchSC.vue?vue&type=script&lang=js&"
export * from "./searchSC.vue?vue&type=script&lang=js&"
import style0 from "./searchSC.vue?vue&type=style&index=0&id=277e27a8&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports